import { RawTexture } from '@babylonjs/core/Materials/Textures/rawTexture';
import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import type { Scene } from '@babylonjs/core/scene';

const SIZE = 32;

/**
 * A soft round dot, white with a smooth alpha falloff, for particle effects to tint: generated
 * here, so no image file is fetched (the spells on the board, the sparks of a duel).
 */
export function softDot(scene: Scene, name: string): Texture {
  const data = new Uint8Array(SIZE * SIZE * 4);
  for (let y = 0; y < SIZE; y++) {
    for (let x = 0; x < SIZE; x++) {
      const dx = (x + 0.5) / SIZE - 0.5;
      const dy = (y + 0.5) / SIZE - 0.5;
      const r = Math.sqrt(dx * dx + dy * dy) / 0.5;
      const falloff = Math.max(0, 1 - r);
      const alpha = falloff * falloff * (3 - 2 * falloff);
      const i = (y * SIZE + x) * 4;
      data[i] = data[i + 1] = data[i + 2] = 255;
      data[i + 3] = Math.round(alpha * 255);
    }
  }
  const texture = RawTexture.CreateRGBATexture(
    data,
    SIZE,
    SIZE,
    scene,
    true,
    false,
    Texture.TRILINEAR_SAMPLINGMODE,
  );
  texture.name = name;
  texture.hasAlpha = true;
  return texture;
}
